var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 15.5C4.16667 15.9583 4.54167 16.3333 5 16.3333H15C15.4583 16.3333 15.8333 15.9583 15.8333 15.5V11.3333C15.8333 10.875 16.2083 10.5 16.6667 10.5C17.125 10.5 17.5 10.875 17.5 11.3333V16.3333C17.5 17.25 16.75 18 15.8333 18H4.16667C3.25 18 2.5 17.25 2.5 16.3333V4.66667C2.5 3.75 3.24167 3 4.16667 3H9.16667C9.625 3 10 3.375 10 3.83333C10 4.29167 9.625 4.66667 9.16667 4.66667H5C4.54167 4.66667 4.16667 5.04167 4.16667 5.5V15.5ZM12.5 4.66667C12.0417 4.66667 11.6667 4.29167 11.6667 3.83333C11.6667 3.375 12.0417 3 12.5 3H17.5V8C17.5 8.45833 17.125 8.83333 16.6667 8.83333C16.2083 8.83333 15.8333 8.45833 15.8333 8V5.84167L8.225 13.45C7.9 13.775 7.375 13.775 7.05 13.45C6.725 13.125 6.725 12.6 7.05 12.275L14.6583 4.66667H12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.a0ed03c1844fa3488d35ce7759824d94.svg";
export { ForwardRef as ReactComponent };